export default __webpack_public_path__ + "static/icici-healthadvantedge-508dbc024ca9724d9266d065d604a88a.png";